import { styled } from "@mui/material/styles";
const TransactionsHead = styled("div")(({ theme }) => ({
  "& .head_main": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
    flexDirection: "row",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      paddingTop: "20px",
      "& h6": {
        textAlign: "center",
      },
      "& .head_text": {
        "& span": {
          display: "none",
        },
      },
      "& .head_price": {
        textAlign: "center",
      },
    },
  },

  "& .head_text": {
    "& h6": {
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "18px",
      lineHeight: "25px",
      letterSpacing: "0.1em",
      textTransform: "uppercase",
      color: "#0B0B0B",
      fontFamily: theme.typography.fontFamily,
    },
    "& span": {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "18px",
      lineHeight: "25px",
      textAlign: "center",
      color: "#FF0000",
      fontFamily: theme.typography.fontFamily,
    },
  },
  "& .head_price": {
    "& span": {
      fontWeight: 900,
      fontSize: "40px",
      lineHeight: "55px",
      letterSpacing: "0.02em",
      color: "#0B0B0B",
      fontFamily: theme.typography.fontFamily,
    },
    "& span.due_date": {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "18px",
      lineHeight: "25px",
      textAlign: "center",
      color: "#FF0000",
      fontFamily: theme.typography.fontFamily,
      [theme.breakpoints.down("sm")]: {
        display: "block !important",
      },
      [theme.breakpoints.down("md")]: {
        display: "none",
      },
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
  },
}));
const TransactionsDate = styled("div")(({ theme }) => ({
  "& span": {
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "19px",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
  },
}));
const LoadMoreMain = styled("div")(({ theme }) => ({
  width: "50%",
  margin: "auto",
  marginBottom: "8px",
  marginTop: "5px",
}));

export { TransactionsHead, TransactionsDate, LoadMoreMain };
